import { useContext } from "react"
import { GTIWebButton, Dialog, Typography, Grid, Box, Stack, Icon } from "@gti-controls-v2/web-core";
import useTranslation from "../../hooks/useTranslation";
import { paths } from "../../common/constants/Rutas";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../providers/auth";
import homePageStyles from "../../common/styles/HomePage";
import { titleIcons } from "../../common/constants/TitleIcons";

export const DialogoSesionFinalizo = (props) => {

	const { t } = useTranslation();
	const { logout } = useContext(AuthContext);
	const navigate = useNavigate();
	const styles = homePageStyles;

	const handleClose = () => {
		logout();
		navigate(paths.Login);
	};

	return (
		<>
			<Dialog
				open={props.sesionFinalizo}
				maxWidth="sm"
				fullWidth
			>
				<Box sx={homePageStyles.modal}>
					<Grid container justify="flex-end">
						<Grid item xs={12}>
							<Box sx={styles.modalHeader}>
								<Box>
									<Box
										display="flex"
										justifyContent="center"
										alignItems="center"
									/>
									<Icon
										fontSize={"large"}
										sx={{
											color: titleIcons.info.color,
											marginRight: "16px",
										}}
									>
										{titleIcons.info.src}
									</Icon>

								</Box>
								<Box sx={styles.modalHeaderText}>
									<Typography variant="h6" sx={styles.modalTitle}>
										{t("sistema.modal.sesionFinalizada.titulo")}
									</Typography>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={12}>
							<Box sx={{ pb: 4 }}>
								<Typography variant="body2">
									{t("sistema.modal.sesionFinalizada.descripcion")}
								</Typography>
							</Box>
						</Grid>
						<Grid item xs={12}>
							<Box sx={styles.modalButtons}>
								<Box sx={styles.spacer} />
								<Box>
									<Stack width="100%" direction="row">
										<GTIWebButton
											sx={styles.modalActionButton}
											text={t("sistema.modal.sesionFinalizada.acciones.iniciarSesion")}
											width={"100%"}
											onClick={handleClose}
										/>
									</Stack>
								</Box>
							</Box>
						</Grid>
					</Grid>
				</Box>
			</Dialog>
		</>
	);
};